class Breadcrumb {

	constructor() {
		this.init();
	}

	init() {
    var $window = $(window);
    
    function breadCrumbMobile(){
			if($window.width() < 991){
				$('#breadcrumbs span').css('display', 'none');
				var designated_survivor = $('#breadcrumbs span.breadcrumb_last').parent().find('a');

				if(!$('#breadcrumbs .container > a').length){
					$('#breadcrumbs .container').append(designated_survivor.clone());
				}
			}else{
				$('#breadcrumbs span').css('display', '');
				$('#breadcrumbs .container > a').remove();
			}
		}

		breadCrumbMobile();

		$(window).on('resize', function(){
			breadCrumbMobile();
		});
	}
}

export default Breadcrumb;
